/* eslint-disable id-length */
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import { ConfigMixin } from "./config-mixin";

const regionDisplayConfig = {
  isOnboardingWatermarkEnabled() {
    const cmsGeneralFeatureList = this.platformConfig.cmsGeneralFeatureList;

    const onboardingConfig = getAppFeatureProp(cmsGeneralFeatureList, "sleek_site_onboarding");

    if (!onboardingConfig || !onboardingConfig.enabled) {
      return false;
    }

    const onboardingConfigValue = onboardingConfig.value || {};

    return onboardingConfigValue.is_display_watermark;
  },
  getOnboardingPageProps(pageName) {
    const onboardingProps = this.getOnboardingProps();
    const defaultPageProps = getAppFeatureProp(onboardingProps, "default_pages");

    if (!defaultPageProps || !defaultPageProps.enabled) {
      return null;
    }

    const pageProp = getAppFeatureProp(defaultPageProps.props, pageName);

    return pageProp && pageProp.enabled ? pageProp.value : {};
  },
  getOnboardingProps() {
    const cmsGeneralFeatureList = this.platformConfig.cmsGeneralFeatureList;

    const onboardingConfig = getAppFeatureProp(cmsGeneralFeatureList, "sleek_site_onboarding") || {};

    return (onboardingConfig && onboardingConfig.props) || [];
  },
};

export const RegionDisplayToggleMixin = {
  mixins: [ConfigMixin],
  methods: {
    ...regionDisplayConfig,
  },
};
